import React from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';

const PageContainer = ({ children, className = '' }) => {
  const isMobile = useMediaQuery('(max-width: 640px)');

  return (
    <div className={`flex-1 overflow-auto ${className}`}>
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8 space-y-6 sm:space-y-8 ${isMobile ? 'pb-[140px]' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default PageContainer; 